import { Spinner } from 'uikit/spinners/default'
import styles from './controls.module.scss'

interface GraphLoadingOverlayProps {
  isVisible?: boolean
  message?: string
}

export function GraphLoadingOverlay({ isVisible, message = 'Updating graph...' }: GraphLoadingOverlayProps) {
  if (!isVisible) return null

  return (
    <div className={styles.loadingOverlay}>
      <Spinner size='large' />
      <span className={styles.loadingText}>{message}</span>
    </div>
  )
}
